import React from 'react';

import { isFieldForListingType } from '../../util/fieldHelpers';
import { useConfiguration } from '../../context/configurationContext';

import { Heading } from '../../components';
import { getTaskBudgetValue } from '../../components/ListingCard/taskCardHelpers';

import css from './ListingPage.module.css';

// Task budget fields: shown as one §9 value («56–89 €») under «Бюджет», not as table rows (A12).
const TASK_BUDGET_KEYS = ['budgetMin', 'budgetMax'];

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl } = props;
  const config = useConfiguration();

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = typeof publicDataValue != null ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
        ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
        : schemaType === 'long'
        ? filteredConfigs.concat({ key, value, label })
        : filteredConfigs;
    }
    return filteredConfigs;
  };

  const isTaskListing = publicData.listingType === 'tasks';
  const existingListingFields = listingFieldConfigs
    .reduce(pickListingFields, [])
    .filter(field => !(isTaskListing && TASK_BUDGET_KEYS.includes(field.key)));
  const taskBudget = isTaskListing ? getTaskBudgetValue(publicData, intl, config.currency) : null;

  const budgetSection = taskBudget ? (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionSubheading}>
        {intl.formatMessage({ id: 'ListingPage.budgetTitle' })}
      </Heading>
      <p className={css.taskBudget}>{taskBudget}</p>
    </section>
  ) : null;

  const detailsSection =
    existingListingFields.length > 0 ? (
      <section className={css.sectionDetails}>
        <Heading as="h2" rootClassName={css.sectionSubheading}>
          {intl.formatMessage({
            id: isTaskListing ? 'ListingPage.detailsTitleTask' : 'ListingPage.detailsTitle',
          })}
        </Heading>
        <ul className={css.details}>
          {existingListingFields.map(detail => (
            <li key={detail.key} className={css.detailsRow}>
              <span className={css.detailLabel}>{detail.label}</span>
              <span>{detail.value}</span>
            </li>
          ))}
        </ul>
      </section>
    ) : null;

  return budgetSection || detailsSection ? (
    <>
      {budgetSection}
      {detailsSection}
    </>
  ) : null;
};

export default SectionDetailsMaybe;
